module.exports = __webpack_public_path__ + "img/2025big7.fea2e4af.jpg";